import { DefaultOptions } from '@tanstack/react-query'

export const defaultQueryOptions: DefaultOptions = {
  queries: {
    // データをキャッシュする時間（デフォルト: 5分）
    staleTime: 1000 * 60 * 5,
    
    // キャッシュに保持する時間（デフォルト: 5分）
    gcTime: 1000 * 60 * 5,
    
    // 失敗時のリトライ回数
    retry: 1,
    
    // リトライ間隔
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    
    // ウィンドウフォーカス時の自動再取得を無効化
    refetchOnWindowFocus: false,
    
    // マウント時の自動再取得を有効化
    refetchOnMount: true,
    
    // ネットワーク再接続時の再取得を有効化
    refetchOnReconnect: true,
  },
  mutations: {
    // ミューテーション失敗時のリトライ回数
    retry: 0,
  },
}
